import apiConfig from '../../apiConfig'

export const deleteDepartmentVersionDetail = async (...params) => {
    const response = await apiConfig.post(
        '/API/ADMINISTRATION/DEPARTMENTS/SERVICES/DEL_DEPARTMENT_VERSION_DETAIL',
        {
            Department_Service_Detail_Id: params[1]
        },
        {
            headers: {
                Authorization: `Bearer ${params[0]}`
            }
        }
    )


    if (response.data.Status) {
        return response.data
    }

    return []
}
